import { NgIf } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { Button, ProgressBarComponent } from "@ankaadia/ankaadia-shared-frontend";
import { TranslateDirective } from "../../transloco/translate.directive";
import { NewUiProgressDialogComponent } from "./new-ui-progress-dialog.component";

@Component({
  selector: "app-progress-dialog",
  templateUrl: "./progress-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateDirective, Button, ProgressBarComponent, NgIf],
})
export class ProgressDialogComponent extends NewUiProgressDialogComponent {}
